<template>
  <div class="tab-pane active">
    <clip-loader v-if="loading" />

    <div class="table-responsive">
      <table class="table table-hover">
        <thead class="sortable-table-header">
          <tr>
            <th>{{ trans("admin.cdr.auditAction") }}</th>
            <th>{{ trans("admin.cdr.targetType") }}</th>
            <th>{{ trans("admin.cdr.auditTargetIdentifier") }}</th>
            <th>{{ trans("admin.cdr.actor") }}</th>
            <th>{{ trans("admin.cdr.createdAt") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="event in events" :key="event.id">
            <td>{{ event.action_label }}</td>
            <td>{{ event.target_type_label }}</td>
            <td>{{ event.case_no || event.target_id }}</td>
            <td>{{ event.actor?.full_name }}</td>
            <td>{{ event.created_at_formatted }}</td>
          </tr>
          <tr v-if="events.length === 0">
            <td colspan="5" class="text-center text-muted">
              {{ trans("admin.cdr.noAuditEvents") }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="row-fluid float-right">
      <DerPaginate
        v-model="paginate.current_page"
        :page-count="paginate.last_page"
        :show-go="true"
        @change="getAuditLog"
      />
    </div>
  </div>
</template>

<script>
import ClipLoader from "../../Utils/ClipLoader.vue";
import DerPaginate from "../../../design-system/DerPaginate.vue";
import { practitionerHttpService } from "../../../app/practitioner-portal/store/practitioner-http-service";

export default {
  components: { ClipLoader, DerPaginate },
  data() {
    return {
      loading: true,
      events: [],
      paginate: {
        current_page: 0,
        total: 0,
        last_page: 0,
      },
    };
  },
  created() {
    this.getAuditLog(1);
  },
  methods: {
    getAuditLog(page = 1) {
      this.loading = true;
      practitionerHttpService
        .post("/api/internal/admin/cdr/audit-log", { page })
        .then((res) => {
          this.events = res.data.data;
          this.paginate = {
            current_page: res.data.meta.current_page,
            total: res.data.meta.total,
            last_page: res.data.meta.last_page,
          };
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.userErrorMessage(error);
        });
    },
  },
};
</script>
